@if (!vendorContext) {

  <div class="row">
    <div class="header-actions">
      <button class="close" (click)="close()" title="{{ 'generic.close' | translate }}">
      <span class="icon-view-close" aria-hidden="true">
        <svg>
          <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
        </svg>
      </span>
        <span>{{ 'generic.close' | translate }}</span>
      </button>
    </div>

    <div class="col-lg-3 col-xs-12">
      <div class="col-left p-3" *ngIf="!vendorContext">
        <h2>{{ 'popins.projects.my_projects' | translate }}</h2>
        <p>{{ 'popins.projects.select_project' | translate }}</p>
        <ul>
          @if (datas.kitchenEnabled || datas.kitchenV2Enabled) {
            <li [class.selected]="currentTab == 'kitchen'" (click)="setTab('kitchen')">
              {{ 'popins.projects.my_projects_kitchen' | translate }}
            </li>
          }
          @if (datas.storageEnabled) {
            <li [class.selected]="currentTab == 'storage'" (click)="setTab('storage')">
              {{ 'popins.projects.my_projects_storage' | translate }}
            </li>
          }
          @if (datas.bathroomEnabled) {
            <li [class.selected]="currentTab == 'bathroom'" (click)="setTab('bathroom')">
              {{ 'popins.projects.my_projects_bathroom' | translate }}
            </li>
          }
          @for (app of datas.appsEnabled; track app) {
            @if (app !== 'kitchen') {
              <!-- Vu que kitchen est aussi dans appsEnabled, et bien il est affiché 2 fois dans les tab à gauche -->
              <li [class.selected]="currentTab == app" (click)="setTab(app)">
                {{ 'popins.projects.my_projects_' + app | translate }}
              </li>
            }
          }
          @if (multiCatalog) {
            <li [class.selected]="currentTab == 'all'" (click)="setTab('all')">
              {{ 'popins.projects.my_projects_all' | translate }}
            </li>
          }
        </ul>
      </div>
      <div class="col-left p-3" *ngIf="vendorContext">
      <span class="back" (click)="backToCustomerSearch()"
      >&lt; {{ 'popins.projects.back_customer_search' | translate }}</span
      >
        <h2>{{ 'popins.projects.customer_projects' | translate }}<br />{{ customer.fullName }}</h2>
        <ul>
          @if (!this.contextToDisplay) {
            @if (datas.kitchenEnabled || datas.kitchenV2Enabled) {
              <li [class.selected]="currentTab == 'kitchen'" (click)="setTab('kitchen')">
                {{ 'popins.projects.customer_projects_kitchen' | translate }}
              </li>
            }
            @if (datas.storageEnabled) {
              <li [class.selected]="currentTab == 'storage'" (click)="setTab('storage')">
                {{ 'popins.projects.customer_projects_storage' | translate }}
              </li>
            }
            @if (datas.bathroomEnabled) {
              <li [class.selected]="currentTab == 'bathroom'" (click)="setTab('bathroom')">
                {{ 'popins.projects.my_projects_bathroom' | translate }}
              </li>
            }
            @for (app of datas.appsEnabled; track app) {
              @if (app !== 'kitchen') {
                <li [class.selected]="currentTab == app" (click)="setTab(app)">
                  {{ 'popins.projects.customer_projects_' + app | translate }}
                </li>
              }
            }
            @if (multiCatalog) {
              <li [class.selected]="currentTab == 'all'" (click)="setTab('all')">
                {{ 'popins.projects.customer_projects_all' | translate }}
              </li>
            }
          } @else {
            <li [class.selected]="currentTab == this.contextToDisplay" (click)="setTab(this.contextToDisplay)">
              {{ 'popins.projects.customer_projects_' + this.contextToDisplay | translate }}
            </li>
          }
        </ul>
      </div>
    </div>

    <div class="col-lg-9 col-xs-12">
      <div class="row p-4 project-list project-list-skeleton" *ngIf="loading">
        <div class="col-12">
          <div class="project-search-skeleton mb-4">
            <p-skeleton height="2.75rem" width="40%" borderRadius="20px"></p-skeleton>
          </div>
        </div>

        @for (item of projectSkeletonItems; track $index) {
          <figure class="col-xl-3 col-sm-4 col-xs-6">
            <div class="card skeleton-card">
              <p-skeleton width="100%" height="10rem"></p-skeleton>
              <figcaption class="card-body">
                <p-skeleton width="75%" height="1.1rem"></p-skeleton>
                <p-skeleton width="45%" height="0.9rem"></p-skeleton>
                <p-skeleton width="90%" height="2.5rem" borderRadius="18px"></p-skeleton>
              </figcaption>
            </div>
          </figure>
        }
      </div>

      <div class="row p-4 project-list" *ngIf="!loading">
        <div class="col-12">
          <div class="input-group project-search-bar mb-4">
            <input type="text" class="form-control" [(ngModel)]="searchInputValue" placeholder="Rechercher un projet" />
            <div class="input-group-append">
              <button
                class="btn btn-outline-secondary"
                (click)="filterDisplayedProjects()"
                type="button"
                id="button-addon2">
                <svg>
                  <use
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    xlink:href="assets/img/icons.svg#icon-action-search"></use>
                </svg>
              </button>
            </div>
          </div>
        </div>
        @if (currentTab != 'all') {
          <figure class="col-4 col-xl-3">
            <div class="card card-add-project" (click)="newProject($event)">
              <svg class="card-img-top">
                <use xmlns:xlink="http://www.w3.org/1999/xlink"
                     xlink:href="assets/img/icons.svg#icon-action-zoom"></use>
              </svg>
              <figcaption class="card-body">
                <h3 class="card-title">
                  {{ 'popins.projects.new_project' | translate }}
                </h3>
              </figcaption>
            </div>
          </figure>
        }

        <figure class="col-xl-3 col-sm-4 col-xs-6" *ngFor="let project of displayedProjects">
          <div class="card" (click)="openProject(project, $event)">
            <div class="embed-responsive embed-responsive-4by3">
              <div class="embed-responsive-item"
                   [style.background-image]="'url(\'' + project.thumb + '\')' | safeStyle">
                <div class="v-center">
                  <ng-casto-button
                    class="primary"
                    (click)="openProject(project, $event)"
                    [label]="'popins.projects.open_project' | translate"></ng-casto-button>
                  <br />
                  <button (click)="duplicateProject(project, $event)" [title]="'generic.duplicate' | translate">
                    <svg>
                      <use
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        xlink:href="assets/img/icons.svg#icon-action-duplicate"></use>
                    </svg>
                  </button>
                  @if (!project.is_locked && !project.inTunnel) {
                    <button (click)="deleteProject(project, $event)" [title]="'generic.delete' | translate">
                      <svg>
                        <use
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          xlink:href="assets/img/icons.svg#icon-action-delete"></use>
                      </svg>
                    </button>
                  } @else {
                    <button
                      class="btn-disabled"
                      [title]="'generic.delete' | translate"
                      tooltipPosition="top"
                      [pTooltip]="
                      (project.inTunnel ? 'popins.projects.locked_tooltip_tunnel' : 'popins.projects.locked_tooltip')
                        | translate
                    ">
                      <svg>
                        <use
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          xlink:href="assets/img/icons.svg#icon-action-delete"></use>
                      </svg>
                    </button>
                  }
                </div>
              </div>
            </div>
            <figcaption class="card-body">
              <h3 class="card-title">{{ project.projectName }}</h3>
              <p [innerHtml]="project.description | nl2br"></p>
              <p class="project-date">
                {{ project.dateUpdate | date: 'dd/MM/yyyy HH:mm' }}
              </p>
              <div class="quotation-container">
                @if (project.hasQuotation) {
                  <div class="quotation left">
                    <p>{{ 'popins.projects.quotation' | translate }}</p>
                    <p class="expiration-date">
                      {{ 'popins.projects.quotation-expiration' | translate }}
                      {{ project.quotationExpirationDate | date: 'dd/MM/yyyy' }}
                    </p>
                  </div>
                }
                @if (project.hasDiscount && project.hasQuotation) {
                  <div class="quotation right">
                    <p>{{ 'popins.projects.quotation-discount' | translate }}</p>
                  </div>
                }
              </div>
            </figcaption>
          </div>
        </figure>
      </div>
    </div>
  </div>
} @else {
  <div class="project-list-container">
    <div class="header-actions">
      <button class="close" (click)="close()" title="{{ 'generic.close' | translate }}">
      <span class="icon-view-close" aria-hidden="true">
        <svg>
          <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
        </svg>
      </span>
        <span>{{ 'generic.close' | translate }}</span>
      </button>
    </div>

    <div class="project-list-header">
      <ng-casto-button class="secondary" [label]="'project-list.return'|translate"
                       [faIcon]="faChevronLeft" (click)="backToCustomerSearch()"></ng-casto-button>
      <span class="casto-title large sentry-mask" [innerHTML]="'project-list.title'|translate:{
    name: customer.fullName
    }"></span>
      @if (!loading) {
        <span class="casto-tag" [innerHTML]="'project-list.nb-project'|translate:{
      count:displayedProjects.length,
      s:displayedProjects.length > 1 ? 's' : ''
      }"></span>
      }

    </div>


    <div class="project-list-actions">
      <ng-casto-button class="primary" [faIcon]="faSearch" (click)="filterDisplayedProjects()"></ng-casto-button>
      <p-floatLabel>
        <input pInputText id="searchProject" [(ngModel)]="searchInputValue" />
        <label for="searchProject" [innerHTML]="'project-list.search-placeholder'|translate"></label>
      </p-floatLabel>
      <p-floatLabel>
        <p-dropdown
          [options]="contextDropdownItems"
          [(ngModel)]="selectedContext"
          optionLabel="name"
          inputId="selectContext"
          (onChange)="setTabFromDropdown($event)" />
        <label for="selectContext" [innerHTML]="'project-list.project-type-placeholder'|translate"></label>
      </p-floatLabel>
      <p-splitButton
        #splitBtn
        [label]="'search-bar.create-project' | translate"
        styleClass="casto-split-button"
        [model]="contextProjectDropdownItems"
        (onClick)="openDropdown()"
        id="search-bar-create-project-modal" />
    </div>


    <div class="project-list-items">
      @if (!loading) {
        @for (project of displayedProjects; track project) {
          <div class="project-item-container">
            <div class="project-thumbnail" [class]="project.distributionID === contexts.BATHROOM_V2 ? 'bathroomV2-thumbnail' : null">
              <img [src]="project.thumb |safe" alt="thumbnail">
              <div class="actions-overlay">
                <ng-casto-button
                  class="primary"
                  (click)="openProject(project, $event)"
                  [label]="'popins.projects.open_project' | translate"></ng-casto-button>
                <ng-casto-button class="secondary borderless" [faIcon]="faTrash"
                                 [disabled]="isProjectDeleteDisabled(project)"
                                 (click)="deleteProject(project, $event)"></ng-casto-button>
                <ng-casto-button class="secondary borderless" [faIcon]="faCopy"
                                 (click)="duplicateProject(project, $event)"></ng-casto-button>
              </div>
            </div>
            <div class="project-info">
              <div class="project-title">
              <span>
                {{ project.projectName }}
              </span>
              </div>
              <div class="project-detail">
                <p [innerHtml]="project.description | nl2br"></p>
                <p class="project-date">
                  {{ project.dateUpdate | date: 'd/MM/y H:mm' }}
                </p>
              </div>
              <div class="project-tag">
                @if (project.hasQuotation) {
                  <div class="quotation">
                    <p>{{ 'popins.projects.quotation' | translate }}</p>
                    <p class="expiration-date">
                      {{ 'popins.projects.quotation-expiration' | translate }}
                      {{ project.quotationExpirationDate | date: 'dd/MM/y' }}
                    </p>
                  </div>
                }
                @if (project.hasDiscount && project.hasQuotation) {
                  <div class="quotation">
                    <p>{{ 'popins.projects.quotation-discount' | translate }}</p>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      } @else {
        @for (item of projectSkeletonItems; track $index) {
          <div class="project-item-container skeleton-project-item">
            <div class="project-thumbnail">
              <p-skeleton width="100%" height="12rem"></p-skeleton>
            </div>
            <div class="project-info">
              <p-skeleton width="75%" height="1.2rem"></p-skeleton>
              <p-skeleton width="55%" height="1rem"></p-skeleton>
              <p-skeleton width="88%" height="3.25rem" borderRadius="20px"></p-skeleton>
            </div>
          </div>
        }
      }

    </div>

  </div>
}

